export enum ReturnPolicySnapshotStatus {
  Draft = "draft",
  Published = "published",
  Archived = "archived",
}
